export const getPagePlatform = () => {
  if (process.env.NEXT_PUBLIC_APP_ID === 'account') {
    return 'account';
  }

  if (process.env.NEXT_PUBLIC_APP_ID === 'dashboard') {
    return 'meinereisen';
  }

  if (process.env.NEXT_PUBLIC_APP_ID === 'nextgen') {
    return 'website';
  }

  return undefined;
};
